<template>
  <b-modal id="modal-confirm-delete-menu-set-footer" header-class="danger">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div class="w-100"> 
          <h5> {{$t("engine.manageFooter.manu.lblDeleteMenuSet",languageEngine)}} </h5>
        
        </div>
      </div>
      <div class="close px-2" type="button" style="font-size: 18px">
        <i class="fal fa-question-circle"></i>
      </div>
      <div
        @click="closeModal()"
        type="button"
        aria-label="Close"
        id="close-modal-confirm-delete-menu-set-footer"
        class="close-modal"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div>
       {{$t("engine.manageFooter.manu.lblSureDeleteMenuSet",languageEngine)}} <span class="text-danger"> {{item_name}} </span> ?
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="danger" @click="confirm"><i class="far fa-trash-alt"></i> {{$t("engine.manageFooter.manu.lblDelete",languageEngine)}} </b-button>
      <b-button variant="light" @click="closeModal" class="mr-3"> <i class="far fa-times"></i> {{$t("engine.manageFooter.menu.set.lblCancel",languageEngine)}} </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed:{
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    closeModal() {
      this.$emit('clear');
      this.$bvModal.hide("modal-confirm-delete-menu-set-footer");
    },
    confirm() {
      this.$emit('confirmed');
      this.$bvModal.hide("modal-confirm-delete-menu-set-footer");
    }
  },
  props:["id","item_name"]
}
</script>